export default __webpack_public_path__ + "static/media/Gunderland Greaves.a57207eb.jpg";